/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

const TableBodyRow: React.FC<any> = ({ rowData, isExpanded }) => (
  <React.Fragment>{isExpanded ? rowData : []}</React.Fragment>
);

export default TableBodyRow;
